import React, { useEffect, useState } from 'react';
import Timeline from './Timeline.js';
import './TimelinePanel.css';

function TimelinePanel({ isOpen, onClose, timelineData }) {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300); // Match the CSS animation duration
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen && !isClosing) {
    return null;
  }

  return (
    <div 
      className={`timeline-panel-backdrop ${isClosing ? 'closing' : ''}`}
      onClick={handleBackdropClick}
      data-testid="timeline-panel-backdrop"
    >
      <div 
        className={`timeline-panel ${isClosing ? 'closing' : ''}`}
        data-testid="timeline-panel"
      >
        <div className="timeline-panel-header">
          <h2>Meeting Timeline</h2>
          <button 
            className="timeline-panel-close"
            onClick={handleClose}
            title="Close Timeline"
          >
            <i className="ti ti-x"></i>
          </button>
        </div>
        
        <div className="timeline-panel-content">
          <Timeline timelineData={timelineData} />
        </div>
      </div>
    </div>
  );
}

export default TimelinePanel;
